<template>
<v-app id="inspire">

    <m-global-snackbar/>

<div
    style="text-align: center; margin-top: 20px; margin-bottom: 7px;"
>
     <img 
        src="@/assets/tasting/ledson.png" 
        style="max-width: 325px;"
    />
</div>

<div
    style="font-size: 32px; text-align: center;"
    v-if="$route.params.one_year == null"
>
    Your Tasting<br/>
    <span style="font-size: 20px">July 3rd, 2019</span>
</div>

<div
    style="font-family: 'El Messiri'; color: #5C215F; font-size: 32px; text-align: center;"
    v-if="$route.params.one_year != null"
>
    One year ago today...<br/>
    <span style="font-size: 20px">July 3rd, 2019</span>
</div>

<v-container>


    <m-tasting-card
        hero_src="rose.jpg"
        title="2019 Russian River Valley Pinot Noir Rosé"
        desc="The appearance of our Russian River Valley Pinot Noir Rosé is reminiscent of a Sonoma sunset and gives off stunning aromas of apple, fresh strawberry and rose petal. Juicy white peach and strawberry spread over every inch of the palate accented by just the right amount of acidity and lead to a fresh and crisp finish that keeps you coming back for more."
    />

    <m-tasting-card
        hero_src="viogner.jpg"
        title="2018 Sonoma Coast 'Grove Vineyard' Viognier"
        desc="The 2018 Viognier from our Estate Grove Vineyard at the Sonoma Coast evokes visions of a posh flower garden. It’s crisp and fresh boasting a sumptuous bouquet of ripe apricot and fresh melon accented by exotic floral notes. Elegant notes of white peach and fresh lemony flavors with soft floral touches spill over the palate. Its excellent vibrant acidity structure is moderated by subtle honeyed apricots and honeysuckle on the lingering finish."
    />

     <m-tasting-card
        hero_src="red1.jpg"
        title="2017 California 'Hood Mountain' Gunsight"
        desc="Our Gunsight consistently hits its mark with a gorgeous dusty ruby glow and expressive aromas of luscious ripe plum and cherry. Medium-bodied and approachable, the palate is covered by a lively texture full of blackberry, huckleberry, and ripe raspberry. Fresh plum, dark chocolate, and gingerbread backed by soft tannins build on a generous finish that will most definitely leave an impression."
    />

      <m-tasting-card
        hero_src="red2.jpg"
        title="Redwood Valley 'Ricetti Lane' Late Harvest Zinfandel 'Port Style' Sweet Ida May"
        desc="The ‘Sweet Ida May’ Late Harvest Zinfandel (produced in a port style) will satisfy even the most discerning palate. It’s a beautifully balanced wine showing spectacular depth of flavor unfolding across the palate in layers of richness and texture.Exuding a deep purple color with rich aromas of dark cherry and blackberry and intense flavors of black plum, cassis, and chocolate on the palate, this wines long finish creates a perfectly balanced sense of completeness."
    />


   

</v-container>
</v-app>
</template>

<script>
export default {
    data() {
        return {
        }
    },
}
</script>

<style lang="scss" scoped>
</style>